import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { of } from 'rxjs'
import { switchMap, catchError } from 'rxjs/operators'

export interface WeatherForecast {
  sunrise: string
  sunset: string
  weathercode: string
  windspeed: string
  winddirection: string
  humidity: string
  lowTemperature: string
  highTemperature: string
}

export interface WeatherData {
  location: string
  forecastStart: string
  forecasts: WeatherForecast[]
}

@Injectable({
  providedIn: 'root',
})
export class QuadrigaWeatherService {
  constructor(private http: HttpClient) {
    // do nothing
  }

  fetchWeatherData(city = 'PARIS') {
    const url = `http://hubprod.quadriga.com/xml/quadriga.php?location=${encodeURIComponent(city)}&siteid=3770&time=1000`

    return this.http.get(url, { responseType: 'text' }).pipe(
      switchMap(xmlText => {
        try {
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(xmlText, 'text/xml')

          const location = xmlDoc.querySelector('location')?.textContent || city
          const forecastStart = xmlDoc.querySelector('forecast_start')?.textContent || ''

          const forecasts: WeatherForecast[] = Array.from(xmlDoc.querySelectorAll('forecast')).map(forecast => ({
            sunrise: forecast.querySelector('sunrise')?.textContent || '',
            sunset: forecast.querySelector('sunset')?.textContent || '',
            weathercode: forecast.querySelector('weathercode')?.textContent || '',
            windspeed: forecast.querySelector('windspeed')?.textContent || '',
            winddirection: forecast.querySelector('winddirection')?.textContent || '',
            humidity: forecast.querySelector('humidity')?.textContent || '',
            lowTemperature: forecast.querySelector('low-temperature')?.textContent || '',
            highTemperature: forecast.querySelector('high-temperature')?.textContent || '',
          }))

          return of({
            location,
            forecastStart,
            forecasts,
          })
        } catch (error) {
          console.error('Error parsing weather data:', error)
          return of(null)
        }
      }),
      catchError(error => {
        console.error('Error fetching weather data:', error)
        return of(null)
      })
    )
  }
}
